import { useLayoutEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, CircularProgress, Stack, useMediaQuery } from '@mui/material'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { useGetUserByIdQuery } from '../../../api/users'
import type { TActiveUserResponse } from '../../../api/types'
import { isDeletedUser } from '../../../utils/deletedUserDisplay'
import { MainBox, SideBox, StackStyle } from './style'
import { PureLightTheme } from '../../../styles/theme'
import { NotFound } from '../../../components/ui-kit/NotFound'
import { UserDeletedAccountStub } from '../../../components/User/UserDeletedAccountStub'
import { UserDescription } from '../../../components/User/UserDescription'
import { UserInfo } from '../../../components/User/UserInfo'

export const UserPage = () => {
  useLayoutEffect(() => {
    document.title = 'Профиль пользователя'
  }, [])

  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const { slug: slugParam } = useParams<{ slug: string }>()
  const slug = (slugParam ?? '').trim()

  const { data, isLoading, isError } = useGetUserByIdQuery(slug ? slug : skipToken)

  if (!slug) {
    return <NotFound text="Пользователь не найден" />
  }

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%" width="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError || !data) {
    return <NotFound text="Пользователь не найден" />
  }

  if (isDeletedUser(data)) {
    return <UserDeletedAccountStub />
  }

  const activeUser = data as TActiveUserResponse

  return (
    <Stack direction="row" sx={StackStyle}>
      <Box sx={MainBox}>
        <UserDescription user={activeUser} />
      </Box>
      {!isMobile && (
        <Box sx={SideBox}>
          <UserInfo user={activeUser} />
        </Box>
      )}
    </Stack>
  )
}
